import {getAutocompleteState} from '../state/autocompleteState'
import {emitAutocompleteValue} from "./globalizeValues"

function unselect(store: any): void {
    store.data.selected.autocompleteValue = null
    emitAutocompleteValue(null)
    getAutocompleteState().state.showTopStations = true
}

export default unselect
